bcp47
	en-US
name
	English
name.short
	en

page.title
	cryptopup

chains.label
	Chain
address.label
	Destination wallet address
count.label
	Amount (USDT)

button.copy
	Copy URL
button.copied
	✔️ Copied
